import styled, { css } from "styled-components";

export const Title = styled.p`
  ${({ theme }) => css`
    color: ${theme.lightTheme.colors.text};
    font-size: ${theme.font.size.default}
    font-weight: ${theme.font.weight.bold};
  `}
`;
